module.exports = __webpack_public_path__ + "img/empty-table-history-success-booking.5434b323.svg";